import { CreateUserDialog } from "./dialogs/CreateUserDialog";
import { USERS_PAGE_INTRO } from "../usersPage.constants";

interface UsersPageIntroProps {
  onCreated: () => void;
}

export function UsersPageIntro({ onCreated }: UsersPageIntroProps) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <p className="max-w-2xl text-sm text-muted-foreground">{USERS_PAGE_INTRO}</p>
      <CreateUserDialog onCreated={onCreated} />
    </div>
  );
}
